module.exports = __webpack_public_path__ + "media/images/pic/anime/green-heart-7c5434596d8f0fb0831308a84c08664d.svg";